import { Input, Output, EventEmitter, SimpleChanges, Component,input } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { FormsModule, FormArray, } from '@angular/forms';
import { ClickedOutsideDirective } from '../../directives/clicked-outside.directive';
import { ContentMapperService } from '../../../app/core/services/content-mapper-service';
import { ToastrService } from 'ngx-toastr';
import { ttd_endpoint } from '../../../app/data/api-endpoint/ttd-endpoint';

@Component({
  selector: 'app-shared-dropdown-component',
  imports: [CommonModule, FormsModule, ClickedOutsideDirective],
  templateUrl: './shared-dropdown-component.html',
  styleUrl: './shared-dropdown-component.scss'
})
export class SharedDropdownComponent {

 

  @Input() items: any[] = [];
  @Input() selectItems?: FormArray
  @Input() title: string = ''
  @Input() isSubmitted: boolean = false
  @Input() selectAll: boolean = true
  @Input() newCreation: boolean = false


  customWidth = input<boolean>(false);


  @Output() itemChange = new EventEmitter<any>();
  @Output() selectAllChange = new EventEmitter<any>();
  @Output() clearAll = new EventEmitter<void>();
  @Output() removeItem = new EventEmitter<number>();


  filteredCategoryOptions: any[] = [];
  isDropdownOpen = false;
  showCustomCateogory: boolean = false
  searchTerm = '';
  customCategory: string = ''
  debounceTimeout: any
  currentIndex: any
  filterQuery: any
  addNew = 'assets/img/add-new.svg';
  cross = 'assets/img/cross.png';
  tick = 'assets/img/tick.svg';




  constructor(private _contentMapper: ContentMapperService, private toastr: ToastrService) {

  }



  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items'] && changes['items'].currentValue) {
      this.filteredCategoryOptions = structuredClone(this.items);
    }

    
  }


  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen
  }

  getFilteredOptions() {
    return this.filteredCategoryOptions;
  }

  closeDropdown() {
    this.isDropdownOpen = false;
  }

  onSearch(e: Event): void {
    const value = (e.target as HTMLInputElement).value;
    this.searchTerm = value
    clearTimeout(this.debounceTimeout);

    this.debounceTimeout = setTimeout(() => {
      if (!value) {
        this.filteredCategoryOptions = this.items
        return
      }
      this.filteredCategoryOptions = this.items.filter((item: any) => {
        const regex = new RegExp(`${value.trim()}`, 'i');
        return regex.test(item['name']);
      });
    }, 300);
  }

  onItemChanged(e: Event, item: any) {
    this.itemChange.emit({ event: e, data: item });
  }
  onSelectAllChanged(event: Event) {
    this.selectAllChange.emit(event);
  }

  onClearAll() {
    this.clearAll.emit();
  }

  removeItemFromArray(index: number) {
    this.isDropdownOpen = false
    this.removeItem.emit(index);
  }

  addNewCustomCategory() {
    this.customCategory = ''
    this.showCustomCateogory = true
  }
  closeCustomCategory() {
    this.showCustomCateogory = false

  }



  isChecked(name: string) {
    const formArray = this.selectItems as FormArray;
    const checked = formArray && formArray?.controls.find((x: any) => {
      return (x?.value?.name) === name
    });
    return !!checked;
  }


  isAllChecked() {
    const items = this.items ?? [];
    const selected = this.selectItems?.controls ?? [];
    if (items.length === 0 || selected.length === 0) {
      return false;
    }
    const selectedSet = new Set(selected.map(ctrl => ctrl.value?.['name']));
    return items.every(item => selectedSet.has(item['name']));
  }

  saveCustomCategories() {
    if (!this.customCategory.trim()) {
      this.toastr.error('Please enter a category name before saving.');
      return;
    }
    this._contentMapper.post(ttd_endpoint.custom_categories, { category: this.customCategory.trim() }).subscribe({
      next: (response: any) => {
        this.customCategory = ''
        this.showCustomCateogory = false
        this.toastr.success(response.message)
      }, error: (error: any) => {
        this.toastr.error(error?.error.message)
      }
    })

  }




  ngOnDestroy(): void {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
  }

}
